import { useEffect, useState } from 'react'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { useNavigate } from 'react-router-dom'
import api from '../api'
import CreateButton from '../components/CreateButton'
import Button from '../components/Button'
import VideoCard from '../components/cards/VideoCard'
import HeaderFooterLayout from '../components/layouts/HeaderFooterLayout'
import TextInput from '../components/TextInput'
import Pagination from '../components/Pagination'
import styles from './Videos.module.css'

const PER_PAGE = 12
export default function Videos() {
  const navigate = useNavigate()
  const [videos, setVideos] = useState([])
  const [page, setPage] = useState(0)
  const [count, setCount] = useState(0)
  const [query, setQuery] = useState('')
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [retry, setRetry] = useState(0)
  useEffect(() => {
    const controller = new AbortController()
    setLoading(true)
    setError(false)
    const timer = setTimeout(async () => {
      try {
        const data = await api.get(query.trim() ? `/admin/videos?q=${encodeURIComponent(query.trim())}` : `/admin/videos?page=${page}&per=${PER_PAGE}`, { signal: controller.signal })
        if (controller.signal.aborted) return
        setVideos(data.videos || [])
        setCount(query.trim() ? (data.videos || []).length : data.count || 0)
      } catch (e) { if (!controller.signal.aborted) setError(true) }
      finally { if (!controller.signal.aborted) setLoading(false) }
    }, query.trim() ? 300 : 0)
    return () => { clearTimeout(timer); controller.abort() }
  }, [query, page, retry])
  return <HeaderFooterLayout>
    <HelmetProvider><Helmet><title>Contenuti - Video</title></Helmet></HelmetProvider>
    <div className={styles.container}><div className={styles.section}><div className={styles.sectionInner}>
      <header className={styles.header}><div><p className={styles.eyebrow}>Contenuti</p><h1>Video</h1><p>Gestisci i video, le copertine e i corsi associati.</p></div><CreateButton onClick={() => navigate('/videos/create/editor')}>Aggiungi video</CreateButton></header>
      <div className={styles.library}>
        <div className={styles.search}><TextInput appearance="modern" type="search" value={query} placeholder="Cerca video" onKeyUp={value => { setQuery(value); setPage(0) }} /></div>
        <div className={styles.listHeader}><h2>Libreria video</h2><span>{!loading && !error ? `${count} video` : ''}</span></div>
        {loading ? <div className={styles.empty} role="status">Caricamento video…</div> : error ? <div className={styles.empty} role="alert">Impossibile caricare i video.<Button appearance="subtle" onClick={() => setRetry(value => value + 1)}>Riprova</Button></div> : videos.length ? <div className={styles.videos}>{videos.map(video => <VideoCard key={video.id} video={video} />)}</div> : <div className={styles.empty}>{query.trim() ? 'Nessun video corrisponde alla ricerca.' : 'Non ci sono ancora video. Aggiungi il primo video per iniziare.'}</div>}
        {!query.trim() && count > PER_PAGE && <div className={styles.pagination}><Pagination total={count} per={PER_PAGE} page={page} onChange={setPage} loading={loading} /></div>}
      </div>
    </div></div></div>
  </HeaderFooterLayout>
}
